import React from 'react';
import { connect } from 'react-redux';

import './LoadingComponent.scss';

// RGAA : le chargement est restitué aux technologies d'assistance
// (role="status" + libellé masqué), le spinner est purement décoratif.
const LoadingComponentBase = ({ LOADING_LABEL }) => (
    <div className="loader flex-container flex-center" role="status">
        <div className="loader-inner" aria-hidden="true" />
        <span className="sr-only">{LOADING_LABEL}</span>
    </div>
);

const mapStateToProps = state => ({
    LOADING_LABEL: state.i18n.common.ACCESSIBILITY.LOADING_LABEL
});

export const LoadingComponent = connect(mapStateToProps)(LoadingComponentBase);



// WEBPACK FOOTER //
// ./src/components/loading/LoadingComponent.js